import {ModuleWithProviders, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {HTTP_INTERCEPTORS} from '@angular/common/http';
import { CachingInterceptor } from './interceptor/Caching.interceptor';
import { NbThemeModule } from '@nebular/theme';
import { HttpExternalTokenInterceptor } from './interceptor/http-external-token.interceptor';

/**
 * Core module
 */
@NgModule({
    imports: [
        NbThemeModule.forRoot({ name: 'default'}),
        CommonModule,
    ],
})
export class CoreModule {
    static forRoot(): ModuleWithProviders<CoreModule> {
        return {
            ngModule: CoreModule,
            providers: [
                { provide: HTTP_INTERCEPTORS, useClass: HttpExternalTokenInterceptor, multi: true },
                { provide: HTTP_INTERCEPTORS, useClass: CachingInterceptor, multi: true },
            ],
        };
    }
}
